; (function (window, document) {
    'use strict'

    var Accordion = {
        init: function () {
            Accordion.bindHeaderClicks()
            Accordion.bindHashLinkClicks()
            Accordion.handleInitialHash()
        },

        bindHeaderClicks: function () {
            // clicking the panel header only toggles—no scroll
            document.addEventListener('click', function (e) {
                var toggle = e.target.closest('.accordian-toggle')
                if (!toggle) return

                e.preventDefault()
                Accordion.togglePanel(toggle)
            })
        },

        bindHashLinkClicks: function () {
            // clicking any other #link inside a .panel-group will scroll + open
            document.addEventListener('click', function (e) {
                var link = e.target.closest('a[href^="#"]:not([href="#"])')
                if (
                    !link ||
                    !link.closest('.panel-group') ||
                    link.classList.contains('accordian-toggle')
                ) {
                    return
                }

                e.preventDefault()
                Accordion.openAndScroll(link.getAttribute('href'))
            })
        },

        handleInitialHash: function () {
            if (window.location.hash && window.location.hash !== '#') {
                // on page load with a hash
                Accordion.openAndScroll(window.location.hash)
            }
        },

        openAndScroll: function (hash) {
            var toggle = document.querySelector(
                '.accordian-toggle[href="' + hash + '"]'
            )
            if (!toggle) return

            // 1) open it
            var isExpanded = toggle.getAttribute('aria-expanded') === 'true'
            if (!isExpanded) Accordion.togglePanel(toggle)

            // 2) then scroll to it
            var scrollTop = toggle.offsetTop - 50
            window.scrollTo({ top: scrollTop, behavior: 'smooth' })
        },

        togglePanel: function (toggle) {
            var panel = toggle.closest('.panel')
            var accordion = panel.closest('.panel-group')
            var targetId = toggle.getAttribute('href').slice(1)
            var target = document.getElementById(targetId)
            var isOpen = toggle.getAttribute('aria-expanded') === 'true'

            // if you only ever want one open at a time:
            if (accordion.classList.contains('accordion--oneopen')) {
                accordion
                    .querySelectorAll('.panel')
                    .forEach(function (other) {
                        if (other === panel) return
                        var oT = other.querySelector('.accordian-toggle')
                        var oC = document.getElementById(oT.getAttribute('href').slice(1))
                        oT.setAttribute('aria-expanded', 'false')
                        oC.classList.remove('in')
                        other.classList.remove('active')
                    })
            }

            if (isOpen) {
                // close
                toggle.setAttribute('aria-expanded', 'true')
                target.classList.add('in')
                panel.classList.add('active')
            } else {
                // open
                toggle.setAttribute('aria-expanded', 'false')
                target.classList.remove('in')
                panel.classList.remove('active')
            }

            // fire your custom events if needed…
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', Accordion.init)
    } else {
        Accordion.init()
    }
})(window, document)
